module.exports = function(dashboard) {
	'use strict'
	dashboard.directive('hcChart', hcChart);
	hcChart.$inject=[];
	function hcChart() {
		return {
            restrict: 'E',
            template: '<div></div>',
            scope: {
                options: '='
            },
            link: function (scope, element, attrs) {
                var el = Highcharts.stockChart(element[0], scope.options);
                scope.$on(attrs.id, function(event, args, socket) {
                    var seriesArr;
                    if(socket) {
                        seriesArr = angular.copy(el.series[0].options.data)
                        seriesArr.push(args)
                    } else {
                        el.xAxis[0].setExtremes();
                        seriesArr = args
                    }
                    el.update({
                        series: [{
                            data: seriesArr,
                            name: 'Users',
                            type: 'area',
                            tooltip: {
                                valueDecimals: 0
                            }
                        }]
                    }) 
                });
            }
        };
	};
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/dashboardModule/js/directive/highChartsDirective.js
// module id = 502
// module chunks = 0